import { create } from 'lodash'
import {
    CUSTOM_ROLE,
    DEFAULT_ROLES,
    RELATIONS,
    USER_RELATIONS
} from '../../app/root/constants'

const en = {
    dashboard: {
        dashboard: 'Dashboard',
        switcherHoverTooltip: 'Set and save your default view',
        defaultViewUpdateFail: 'Failed to update default dashboard view',
        addressUpdateSuccess: 'Successfully updated the location address',
        addressUpdateFail: 'Failed to update location address',
        mapView: 'MapView',
        reports: 'Reports for the last 30 days',
        deviceStatusTooltipText: {
            inactive: 'These devices are not in use',
            critical: 'These devices require inspection',
            info: 'The devices are functioning normally',
            warning:
                'The devices possibly have connectivity problems or the battery is low'
        },
        loggedInAs: 'Logged in as: '
    },
    customers: {
        customer: 'Customer',
        customers: 'Customers',
        plan: 'Software plan',
        noCustomers: 'No customers found',
        noCustomer: 'Customer was not found',
        hotswapPortal: 'HotSwap Portal',
        hotswapPortalAccess: 'Allow access to the Hot Swap Process',
        hotswapUpdateService: 'Update Service',
        hotswapUpdateServiceAccess: 'Allows the Update Service Option',
        hotswapWelcomeEmail: 'HotSwap Welcome Email',
        customerUsersTable: 'Customer Users Table',
        errorGettingUsersListForCustomer:
            'Error getting users list for customer.'
    },
    hotSwap: {
        capacityIssueMessage:
            'Dear customers, due to the current high workload caused by vacations and JERRY3 orders, Hotswap bookings are released every Thursday at 3 PM. If Hotswap bookings are currently not possible, we kindly ask for your patience. We update the capacities every week. If you have any questions, please contact m.weigert@traplinked.com directly.',
        hotSwap: 'HotSwap',
        hotSwapAdmin: 'HotSwap Admin',
        hotSwapOrders: 'HotSwap Orders',
        startHotSwap: 'Start HotSwap',
        hotSwapVideoManual: 'HotSwap Video Manual',
        videoNotSupported: 'Your browser does not support the video tag.',
        hotSwapType: 'Hotswap Type',
        swapReplacment: 'Swap Replacement',
        description:
            'Some of your devices may drain more battery as expected. To fix this, we developed a new firmware and the old devices need to be exchanged. On this page you can manage the whole process.',
        introVideo: 'Introduction video',
        welcomeTitle: 'Welcome to our HotSwap Process',
        welcomeDesc:
            'We’re glad to have you onboard. Here are some quick tips to get you up and running.',
        summary: {
            changeLocation: 'Change Location'
        },
        hotSwapTableEmptyListMessage:
            'Sorry, there are no hot swap items to display at the moment. Please check back later or contact support for assistance.',
        swap_by_user: {
            label: 'Order Replacement Devices',
            title: 'Swap devices by yourself',
            description:
                'We ship you replacement devices and you swap them on your own',
            features: {
                1: 'Order Replacement Devices',
                2: 'Turn on new devices & turn off old devices',
                3: 'Flexible whenever you need it'
            },
            stepper: {
                firstStepHeader: 'Sheduling Shipping',
                firstStepSubHeader: 'When should we ship the devices',
                secondStepHeader: 'Shipping Address',
                secondStepSubHeader: 'Where should we deliver the devices?',
                thirdStepHeader: 'Summary',
                thirdStepSubHeader: 'Confirm Your HotSwap Order'
            },
            btnText: 'Order devices',
            summary: {
                date: 'Delivery Date',
                address: 'Shipping Address'
            },
            successTitle: 'Successfully scheduled HotSwap',
            successDesc:
                'Congratulations. We will start preparing your devices and will ship them to you on time.',
            footerText: 'Tracking Number:',
            trackingLink: 'Tracking link:',
            detailsPageText: 'Shipping',
            termsAndConditonsLinkPart: 'I agree to the HotSwap',
            termsAndConditonsLink: 'Terms and Conditions',
            termsAndConditonsTextHeader: 'HotSwap conditions',
            termsAndConditonsTextFirstParagraph:
                'In the context of the HotSwap process, you agree to the following conditions:',
            termsAndConditonsTextSecondParagraph:
                'For the exchange of warehouse devices, please create a new location in the traplinked app and name it as ["Your Company Name" + Hot Swap Warehouse Dispatch]. Please move all LoRa devices currently in your warehouse to this newly created location to facilitate the smooth exchange of devices.',
            termsAndConditonsTextThirdParagraph:
                "For the exchange of devices located at customer sites, we kindly ask you to verify the assignment in the traplinked app. If you haven't created any (customer) locations or if you don't use our location feature because you only work through the traplinked interface, please contact us before booking replacement devices through this portal.",
            termsAndConditonsTextFourthParagraph:
                'As part of the HotSwap process, you agree to return the exchanged devices to us (traplinked GmbH, Zollhof 7, 90443 Nuremberg) within 7 days of the successful completion of the HotSwap process. We will cover the shipping costs, and the return label will be included with your replacement devices. If delays in the return shipment occur due to your actions, any additional costs incurred may be passed on to you. We require the exchanged devices to expedite the reworking of all systems as quickly as possible.',
            termsAndConditonsTextFivethParagraph:
                'We are available to assist you and answer any questions you may have throughout the HotSwap process. Thank you for your cooperation and understanding.'
        },
        update_service: {
            label: 'Book a date',
            title: 'Update Service by traplinked',
            description: 'We update your devies at the current location',
            features: {
                1: 'Book an appointment',
                2: 'Updated by traplinked technician',
                3: 'Fast & comfortable'
            },
            stepper: {
                firstStepHeader: 'Book Update Service',
                firstStepSubHeader:
                    'When should the traplinked technician come?',
                secondStepHeader: 'Location Address',
                secondStepSubHeader: 'Where is the location?',
                thirdStepHeader: 'Summary',
                thirdStepSubHeader: 'Confirm Update Service Booking'
            },
            btnText: 'Book an appointment',
            summary: {
                date: 'Date & Time',
                address: 'Location Address'
            },
            successTitle: 'Successfully booked Update Service',
            successDesc:
                'Congratulations. Our technician will be at the defined location at the requested date & time.',
            footerText: 'Technician:',
            detailsPageText: 'Update Service'
        },
        rememberAddress: 'Remember Shipping Address',
        saveAddress: 'Save this address for the next swap.',
        backToDashboard: 'Back to the Dashboard',
        accordionDevicesTable: {
            exchangeDevice: 'Exchange Device',
            connectivity: 'Connectivity',
            hbInterval: 'HB interval',
            trapSide: 'Trap Side',
            wifiData: 'WIFI Data'
        },
        carrier: 'Carrier'
    },
    locations: {
        storageSectionTitle: 'Storage',
        storageSectionNetworkDevicesTitle: 'Network Devices',
        storageSectionDevicesTitle: 'Devices',
        devicesListTitle: 'Devices',
        dragAndDropMsg: 'Drag n drop pin here!',
        floorPlanLoadingError:
            'Error during floor plan uploading. Please try again',
        locations: 'Locations',
        noLocations: 'No locations available',
        searchUser: 'Search user',
        pleaseSelectLocation: 'Please select a location',
        sureNotToSaveLocation:
            "Are you sure you don't want to save the new location?",
        addSubLocation: 'Add sub-location',
        addDevices: 'Add devices',
        removeLocation: 'Remove location',
        devices: 'Devices',
        network: 'Network',
        networkDevice: 'Network Device',
        overview: 'Overview',
        reports: 'Reports',
        stats: 'Statistics',
        shareInfo: 'Access info',
        floorPlan: 'Floor plan',
        pictures: 'Pictures',
        location: 'Location',
        organisation: 'Organization',
        version: 'Version',
        status: 'Status',
        share: 'Share',
        batteryStatus: 'Battery status',
        actions: 'Actions',
        noDevicesAdded: 'No new devices were added to the location',
        devicesOnLocation: 'Devices at this location',
        noDevicesSetupYet: 'No devices have been set up on this location yet.',
        nameCanNotBeEmpty: "The name can't be empty",
        address: 'Address',
        parentLocation: 'Parent location',
        noParentLocation: 'No parent location',
        locationNotFound: 'Location not found',
        deviceName: 'Device name',
        deviceSerial: 'Device serial',
        event: 'Event',
        time: 'Time',
        reportsOnLocation: 'Reports on location',
        noReportsOnLocation: 'No reports at this location yet',
        locationStatistics: 'Location statistics',
        noLocationStatistics: 'No statistics for this location yet',
        locationNotShared: 'This location is not shared with any other user',
        sureRevokeShareAccessLocation:
            'Are you sure you want to revoke access for this user?',
        devicesAmount: 'Devices amount',
        noDevicesToAddFound: 'No devices were found to add.',
        deleteLocationsModalText:
            'Are you sure you want to delete this location? All sub-locations will be deleted, too. All devices will be moved to the Storage. Proceed?',
        dragNDropInfo: `Drag 'n' drop files here, or click to select files.`,
        dragNDropFiles: '(You can upload png, jpeg and pdf files)',
        deleteFloorPlanModal: 'Are you sure you want to delete the floor plan?',
        toDeleteFloorPlanTypeIn:
            'To delete the floor plan please type in this number:',
        goToDevice: 'Go to device',
        removeFromFloorPlan: 'Remove from floor plan',
        noFloorPlan: 'There is no floor plan for this location',
        addFloorPlan: 'Upload floorplan',
        addDevice: 'Add a Device',
        addNewDevice: 'Add a new device',
        devicesInThisLocation: 'Devices in this location',
        floorPlanBtns: {
            appearance: 'Appearance',
            actions: 'Actions',
            add: 'Add Devices',
            allFilters: 'Filters',
            filter: 'Filter Devices',
            delete: 'Delete Floor Plan',
            replace: 'Replace Floor Plan',
            serialLabel: 'Serial Numbers',
            nameLabel: 'Device Name'
        },
        locationsPath: 'Location path',
        locationId: 'Location ID',
        newLocation: '- New location -',
        responsible: 'Responsible',
        onlyResponsibleLocations: 'Highlight my locations (in the tree)',
        unlockMarkers: 'Unlock markers',
        lockMarkers: 'Lock markers',
        responsibleTooltip:
            'The locations that you are responsible for will be marked with small blue dot',
        addResponsible: 'Add responsible',
        add: 'Add',
        scanWithQr: 'Scan',
        allLocations: 'All',
        myLocations: 'My locations',
        userSearchError: 'An error occurred while searching users',
        getResponsiblesError:
            'An error occurred while loading respinsible for this location',
        addResponsibleError:
            'An error occurred while trying to add responsible',
        deleteResponsibleError: 'An error occurred while deleting responsible',
        getResponsibleLocationsError:
            'An error occurred while loading locations for responsible user',
        userNotFound: 'User is not found..',
        noLocationsForResponsible: 'No locations assigned to you yet.',
        assign: 'Assign',
        contact: 'Contact person',
        locationEmail: 'Location Email',
        locationDetails: 'Location Details (Optional)',
        contactPhone: 'Location Phone',
        noFloorplan: 'No Floorplan uploaded yet',
        selectFile: 'Select a file or drop the file here',
        uploadFloorplan: 'Upload Floor Plan',
        editFloorplan: 'Edit Floor Plan',
        crop: 'Crop',
        rotate: 'Rotate',
        save: 'Save',
        somethingWentWrong: 'Oops, Something went wrong',
        heatmap: 'Heatmap',
        escalationLevels: 'Escalation Levels',
        level: 'Level',
        sendAutomaticallyTriggered: 'Send automatically E-Mails',
        days: 'Days',
        hours: 'Hours',
        afterTrapStatus:
            "After the trap has received it's status and did not change it",
        afterTheTrapTriggered:
            'after the trap triggered and the status did not change',
        eMailOfRecipient: 'E-Mail of Recipient',
        addLevel: 'Add level',
        escalationModalSubTitle:
            'The message will be added to the E-Mail together with the device information & Floor Plan Image',
        locationsWithoutAddressLabel:
            'The following locations have no address, please save the address for those locations:',
        locationsWithoutAddressAndWithoutCoordsLabel:
            'The following locations have address but can not be displayed on the map because the address was not found on the map, please verify address of the location',
        floorPlanPinCaution:
            'We recommend restarting the device if you moved it to a new location',
        showCompletedTasks: 'Show completed tasks',
        hideCompletedTasks: 'Hide completed tasks',
        tasksAtThisLocation: 'Tasks at this location',
        createNewTask: 'Create new task',
        tasks: 'Tasks',
        tasksFetchFail: 'Failed to fetch tasks',
        taskCreated: 'Task created successfully',
        taskCreateFail: 'Failed to create task',
        taskUpdated: 'Task updated successfully',
        taskUpdateFail: 'Failed to update task',
        taskDescriptionTooLong:
            'Task description is too long, maximum of 1024 characters allowed',
        includeSubLocations: 'Include sub locations',
        last30Days: 'Last 30 days',
        last7Days: 'Last 7 days',
        clickOnThePFM: 'Click on the point for more information',
        reportsAmount: 'Reports amount',
        settingsAndActions: 'Settings and actions',
        locationSettings: 'Location settings',
        locationActions: 'Location actions',
        baitSettings: 'Jerry Bait settings',
        successWithAmountOfUpdatedDevices:
            'Success! Amount of updated devices:',
        settingsAndActionsAreAppliedToAll:
            'Location based settings and actions are applied to all devices in this location.',
        settingsAndActionsAreNotAppliedToSL:
            'The settings and actions are not being applied to sublocations and devices in sublocations.',
        noSettingsConfiguredYet:
            'No settings configured yet for this location.',
        selectSettingType: 'Select setting type',
        areYouSureYouWantToRemoveThisSetting:
            'Are you sure you want to remove this setting?',
        resetTheActivityThreshold: 'Reset the activity threshold',
        resetTheActivityThresholdDescr:
            'Resets the activity threshold clears the activity count for selected time period',
        locationBasedSettingsAndActions: 'Location based settings and actions',
        lBasedConfirmReplaceBaitQuestion:
            'By confirming this, you will set the last bait replacement date for all devices in this location.',
        lBasedConfirmThresholdResetQuestion:
            'By confirming this, you will reset the activities for all devices in this location. New threshold will be set and activities will be reset for selected time period.',
        lBasedSettingsAreAppliedYouCanNotEdit:
            'The bait weight and activity values are set by the location. Open the location settings to change them.',
        lBasedSettingsAreApplied:
            'Bait weight and activity values are set by the location.',
        confirmPowerOffDescr:
            "This confirms that you have switched off all the devices in this location and sets the status of the devices to 'Inactive'.",
        switchMMModeOnDescr:
            'Switches maintenance mode on for all devices in this location. In maintenance mode the device does not change its status, reports are not being created and notifications are not being sent.',
        switchMMModeOffDescr:
            'Switches maintenance mode off for all devices in this location.',
        confirmMMModeOnDescr:
            'Maintenance mode will be switched on for all devices in this location. In maintenance mode the device does not change its status, reports are not being created and notifications are not being sent.',
        confirmMMModeOffDescr:
            'Maintenance mode will be switched off for all devices in this location.'
    },
    devices: {
        noDeviceMoveHistoryMsg: 'No movement history for this device.',
        getDeviceMoveHistoryEx:
            'Error occured while loading device move history',
        assigned: 'Assigned',
        allDevices: 'All devices',
        details: 'Details',
        devices: 'Devices',
        location: 'Location',
        organisation: 'Organization',
        version: 'Version',
        serialNr: 'Serial Nr',
        name: 'Name',
        deviceSerial: 'Device serial',
        description: 'Description',
        operationModeLabel: 'Operation mode',
        heartbeatCount: 'Heartbeat count',
        mode: 'Mode',
        status: 'Status',
        batteryStatus: 'Battery status',
        actions: 'Actions',
        noDevicesSetup: 'No devices have been set up',
        noUserFromAnotherOrg: 'There is no user from another organization yet.',
        pleseAddUserFromAnotherOrg:
            'Please add a user from another organization.',
        inUserMgmt: 'in User Management',
        chooseUserToShareWith: 'Please choose a user to share with',
        macAddress: 'MAC address',
        battery: 'Battery',
        deviceIsNotFound: 'Device not found',
        nameIsTooShort: 'Name is too short',
        reset: 'Factory reset',
        resetTomStatus: 'Reset status',
        reportCatch: 'Report catch',
        setOffline: 'Confirm power off',
        heartbeatInterval: 'Heartbeat interval',
        occupancyRate: 'Occupancy rate',
        triggerCount: 'Trigger count',
        triggeredSince: 'Triggered since',
        catchCount: 'Catch count',
        traps: 'Traps',
        noReportsNow: 'Currently there are no reports for',
        noReportsForRange: 'For this time range there are no reports for',
        noReportsYet: 'There are no reports yet',
        resetDescr: `Previous statistics for this device will be deleted. Furthermore the following settings will be reset: Name, Description, Heartbeat interval. The device will be set to the status "Inactive".`,
        resetDescrNote: `Note that you will have to reset the battery separately.`,
        reportCatchDescr: `Are you sure that you want to report a catch?`,
        reportCatchSelectReport:
            'For which of the following reports do you want to create an infestation report?',
        setOfflineDescr: `This confirms that you have switched off this device on site. The device is given the status "Inactive".`,
        resetBatteryDescr: `This confirms that you have replaced the batteries of this device on site. The battery counter will be reset to 100%.`,
        resetBattery: `Confirm battery change`,
        resetTOMStatusDescr:
            'The status of this TOM device will be reset to "Online".',
        online: 'Devices online',
        stock: 'Offline',
        warning: 'Warnings',
        error: 'Critical',
        filters: {
            warning: 'Warnings',
            info: 'Devices online',
            inactive: 'Offline',
            critical: 'Critical'
        },
        qrCode: 'QR code',
        serialEmptyError: 'Device without serial number',
        catchDescription: 'Catch description',
        catchDescriptionMessage: 'Here you can add a description for the catch',
        wifiSetSuccess: 'Successfully set WiFi Credentials',
        wifiSetFail: 'Failed setting WiFi Credentials',
        wifiPasswordMinLengthError: 'Must be longer',
        wifiSSIDMinLengthError: "Can't be empty",
        wifiSignalStrength: 'Signal strength',
        wifiSSID: 'WiFi SSID',
        wifiPassword: 'WiFi Password',
        wifiSignalStrengthHover: 'Based on last Heartbeat',
        wifiExcellent: 'Very good',
        wifiGood: 'Good',
        wifiLow: 'Low',
        wifiBad: 'Bad',
        wifiUnknown: 'Unknown',
        operationMode: {
            movement: 'Movement',
            snaptrap: 'Snaptrap',
            insect: 'Insect',
            bait: 'Bait'
        },
        operationModeInsect: 'Insect',
        tom: 'TOM',
        jerry: 'JERRY',
        deviceTypes: {
            tom: 'TOM',
            jerry: 'JERRY',
            'jerry-lora': 'JERRY-LoRa',
            'tm01-1': 'TrapMe',
            trapsensor: 'TrapSensor',
            'jerry-bait-rat': 'JERRY-Bait-Rat'
        },
        deviceOperationMode: 'Operation mode',
        deviceType: 'Device type',
        routerType: 'Router type',
        insectModeTooltip: 'This device is operating in insect mode',
        snaptrapModeTooltip: 'This device is operating in snaptrap mode',
        movementModeTooltip: 'This device is operating in movement mode',
        baitModeTooltip: 'This device is operating in bait mode',
        rearmed: 'Rearmed',
        inactive: 'Inactive',
        deviceIsInactive: 'The device is inactive.',
        deviceStatuses: {
            0: 'Inactive',
            1: 'Active',
            2: 'Heartbeat missed',
            3: 'Triggered',
            4: 'Low battery',
            5: 'Locating and connecting',
            6: 'Unstable connection',
            7: 'Lightly Infested',
            8: 'Heavily Infested',
            9: 'False triggering',
            10: 'Activity (Warning)',
            11: 'Activity (Critical)'
        },
        deviceStatusDescription: {
            0: 'The device is inactive.',
            1: 'The device is online and functioning normally.',
            2: 'There seem to be connection issues: The wifi connection at the position of this device seems to be unreliable.',
            3: 'A snap trap was triggered and requires manual inspection.',
            4: 'The battery level of this device is low. Please change the batteries.',
            5: 'The device is in beacon mode and can be located.',
            6: 'There seem to be connection issues: The wifi connection at the position of this device seems to be unreliable.',
            7: 'A user reported a light infestation for this device.',
            8: 'A user reported a heavy infestation for this device.',
            9: 'A user reported a false triggering of a snap trap for this device.',
            10: 'A user reported activity at this device.',
            11: 'A user reported critical activity at this device.'
        },
        deviceStatusShortDescription: {
            0: 'Inactive',
            1: 'Active',
            2: 'Heartbeat missed',
            3: 'Triggered',
            4: 'Low battery',
            5: 'Locating and connecting',
            6: 'Unstable connection',
            7: 'Lightly Infested',
            8: 'Heavily Infested',
            9: 'False triggering',
            10: 'Activity (Warning)',
            11: 'Activity (Critical)'
        },
        deviceLastReportTypeShortDescription: {
            0: 'Online', // successfully_set_up
            1: 'Online', // restarted
            2: 'Triggered',
            3: 'Online', // rearmed
            '3-bait': 'Bait available',
            4: 'Heartbeat missed',
            5: 'Down',
            6: 'Locating and connecting',
            11: 'Online', // online_again
            12: 'Inactive',
            13: 'Unstable connection',
            15: 'Lightly Infested',
            16: 'Heavily Infested',
            17: 'False triggering',
            18: 'Activity (Warning)',
            19: 'Activity (Critical)',
            20: 'Catch',
            21: 'Activity noticed',
            22: 'Activity threshold reached',
            23: 'Bait low',
            24: 'Activity threshold reached and bait low',
            25: 'Activity threshold reset'
        },
        changeOperationMode:
            "You've chosen a different mode. In order to apply the change, please turn your TOM device off and on again.",
        pestControlSystemLabel: 'Pest control system',
        pestControlSystemNotSelected: 'Not selected',
        pestControlSystems: {
            1: 'AF-Box (Rat)',
            2: 'nagtag (Mouse)',
            3: 'nagtag (Rat)',
            4: 'Metal Tunnel (Rat)',
            5: 'SpeedBreak (Mouse)',
            6: 'GSG (Mouse)',
            7: 'Flexible Stand',
            8: 'Heisenberg Cockroach Detector',
            9: 'Agrisense Moth Funnel Trap',
            10: 'UV Fly Trap (any)',
            11: 'GSG (Rat)'
        },
        deviceActions: 'Device actions',
        serialNumberSearchModal: {
            header: 'Search the list of serial numbers',
            subHeader:
                'Here you can paste the list of device serial numbers with each serial number on a new line, as follows:',
            placeHolder: 'Serial numbers'
        },
        tableConfigurationModal: {
            header: 'Configure table columns',
            subHeaderMainly: 'Mainly used',
            subHeaderAdditional: 'Additional'
        },
        moveDevicesModal: {
            header: {
                1: 'Where should it move to?',
                2: 'Move device(s) to location'
            },
            totalNumber: 'Total number:'
        },
        configureTableLabel: 'Configure table',
        history: 'History',
        move: 'Move',
        pestControlSystem: 'System',
        transferMode: 'Transfer mode',
        cellular: 'Cellular',
        connectedGateway: 'LoRa gateway',
        gatewayNotFound: 'Gateway not found',
        gatewayLastSignal: 'Last signal',
        notAssigned: 'Not assigned',
        moveDToL: 'Move devices to location',
        youAreNotAbleToMoveTheseDevices:
            "You're not able to move these devices either since the locations that they are in are not assigned to you or you only have a read access for these. Please check your role or contact your organisation manager.",
        devicesAmount: 'Devices amount',
        noDevicesYouCanMove:
            'There are no devices that you can move to another location from which you have selected',
        devicesReadyToMove: 'These devices are ready to be moved.',
        devicesSelected: 'Selected',
        moveToLocation: 'Move to location',
        delete: 'Delete',
        youAreNotAbleToDeleteTheseDevices:
            "You're not able to delete these devices either since the locations that they are in are not assigned to you or you don't have delete permissions for these. Please check your role or contact your organisation manager.",
        devicesRemovedFromOrg:
            'Devices have been removed from organization successfully',
        deleteDevicesFromOrg: 'Delete devices from your organization',
        noDevicesYouCanDelete: 'There are no devices that you can delete',
        devicesReadyToDelete: 'These devices are ready to be deleted.',
        areYouSureYouWantToDeleteDevices:
            'Are you sure you want to delete devices? The devices will be deleted from your account and the devices will no longer be visible in the devices list.',
        devicesSwitchedOffSuccessfully:
            'Devices have been switched off successfully',
        noDevicesYouCanSwitchOff:
            'There are no devices that you can confirm switch off for',
        devicesReadyToSwitchOff: 'These devices are ready to be switched off.',
        areYouSureYouWantToConfirmSwitchOff:
            'Are you sure you want to confirm the switch off for these devices? This confirms that you have switched off the devices on site. The devices will be given the status "Inactive"',
        devicesSwitchedOnMModeSuccessfully:
            'Maintenance mode has been switched on successfully',
        noDevicesYouCanSwitchOnMMode:
            'There are no devices that you can switch on maintenance mode for',
        forTheseDevicesYouCanSwitchOnMMode:
            'For these devices you can switch on maintenance mode.',
        areYouSureYouWantToConfirmSwitchOnMMode:
            'Are you sure you want to switch on of maintenance mode for these devices? In maintenance mode reports are not being created and notifications are not being sent.',
        youAreNotAbleToSwitchOffTheseDevices:
            "You're not able to switch off these devices either since the locations that they are in are not assigned to you or you don't have update permissions for these. Please check your role or contact your organisation manager.",
        youAreNotAbleToSwitchOnMModeTheseDevices:
            "You're not able to switch on maintenance mode these devices either since the locations that they are in are not assigned to you or you don't have update permissions for these. Please check your role or contact your organisation manager.",
        areYouSureConfirmReplacementOfBait:
            'Are you sure you want to confirm the replacement of the bait?',
        areYouSureYouWantToResetTheActivityThreshold:
            'Are you sure you want to reset the activity threshold?',
        baitMonitoring: 'Bait Monitoring',
        enablesOrDisablesBaitWeightTracking:
            'Enables or disables bait weight tracking',
        activityAlertThreshold: 'Activity Threshold',
        whenTheNotificationAlertShouldBeTriggered:
            'When the notification / alert should be triggered',
        per: 'per',
        hours: 'hours',
        days: 'days',
        baitType: 'Bait Type',
        whichBaitAreYouUsing: 'Whats the weight / type of the bait?',
        calibration: 'Bait threshold',
        notifiedWhenBaitWeightLowerThan:
            'Whats the calibration of the bait pad? You will receive a notification once the bait is lower than this weight.',
        baitPad: 'Bait Pad',
        replaceBait: 'Confirm replacement of bait',
        resetsTheBaitStatusToAvailable:
            'Sets the time of the last bait replacement',
        lastReplacement: 'Last Replacement',
        baitLowCount: 'Bait Low Count',
        activityCount: 'Activity Count',
        activitiesThreshold: 'Activities Threshold',
        last: 'last',
        lastThresholdReset: 'Last Threshold Reset',
        activities: 'Activities',
        activitiesSummary: 'Activities Summary',
        trackActivitiesInsights: 'Track activities insights',
        bait: 'Bait',
        baitAvailable: 'Bait Available',
        baitLow: 'Bait Low',
        baitStatusDebounceInfo:
            'The Bait Low and Bait Available statuses are only updated after no motion has been detected on the bait pad for {{minutes}} minutes. When setting up the device, switch on the <bold>Maintenance mode</bold> so that the status is displayed in real time.',
        manufacturerAndType: 'Manufacturer / Type',
        overrideLocationSettings:
            'Use separate monitoring values for this device',
        overrideLocationSettingsDescription:
            'Turn this on when this device needs different bait weight or activity values than the other devices at this location. These values remain active until you turn this off or reset the device.',
        deviceSettingsSource: 'Uses device settings',
        monitoringValuesSetForLocation: 'Uses settings from',
        baitAndActivitySettings: 'Bait and activity settings',
        locationSettingsOverrideMoveWarningTitle: 'Keep separate settings?',
        locationSettingsOverrideMoveWarningText:
            'One or more selected devices have their own bait weight or activity settings. After the move, these settings will remain on the devices. Settings from the new location will not be applied.',
        locationSettingsOverrideMoveConfirm: 'Move and keep settings'
    },
    simCards: {
        simCard: 'SIM Card',
        simCardSerialNumber: 'SIM Card Number',
        activate: 'Activate',
        deactivate: 'Deactivate',
        addSimCardLabel: 'Add SIM Card',
        addSimCardTooltipText:
            'There is no SIM Card assigned to this Network Device. You can add it manually',
        simCardEmptyError: "Can't be empty",
        simCardNotValidIccidError: 'Invalid format of SIM Card Number',
        pendingStatusText:
            'Sim card status is being changed, it can take up to 5 minutes',
        standByStatusText:
            'The SIM card is waiting to transmit data and will become active once it does',
        billingDetails: {
            totalSimCardsText: 'Activated Network Devices',
            totalSimCardsTextItalic: '(Current month)',
            billing: 'Billing',
            tooltipText:
                'The amount will automatically be deducted from your account on the last day of each month',
            currencySymbol: '€'
        }
    },
    reports: {
        sentAutomatically: 'Sent automatically',
        noSharingHistory: 'No reports sent',
        sharingHistory: 'Report sent',
        sharedBy: 'by',
        toEmails: 'to',
        ccEmails: 'cc',
        filterFrom: 'From',
        filterTo: 'To',
        allReports: 'All reports',
        reports: 'Reports',
        deviceName: 'Device name',
        deviceSerial: 'Device serial',
        event: 'Event',
        time: 'Time',
        location: 'Location',
        organisation: 'Organization',
        status: 'Status',
        type: 'Type',
        share: 'Share',
        sendMessage: 'Send message',
        message: 'Message',
        cancle: 'Cancel',
        send: 'Send',
        sendReport: 'Send Report',
        emailSentSuccess: 'Email sent successfuly',
        emailSentFail: 'Opps, something went wrong',
        on: ' on ',
        sentAt: 'Sent at: ',
        failToSend: 'Failed to send: ',
        mailMessageBegin: 'Dear Sir or Madam,',
        mailMessageMainSection:
            'we have detected a triggering of the snap trap ',
        mailMessageMainSection2: '',
        mailMessageMainSection3: 'Please check the trap for catch soon.',
        mailMessageEnd: 'Best regards ',
        mailMessageEnd2: 'FA. Fleschhut',
        noReportsYet: 'No reports yet',
        noReportsForRange: 'No reports for selected time range',
        reportTime: 'Report time',
        evaluationTime: 'Evaluation time',
        reportTypes: {
            0: 'Successfully set up',
            1: 'Restarted',
            2: 'Triggered',
            3: 'Armed',
            '3-bait': 'Bait available',
            4: 'Heartbeat missed',
            5: 'Down',
            6: 'Locating now',
            7: 'Locating fail',
            8: 'Settings updated',
            9: 'Update successful',
            10: 'Battery low',
            11: 'Online again',
            12: 'Turned Off',
            13: 'Unstable connection',
            14: 'Infested',
            15: 'Lightly infested',
            16: 'Heavily infested',
            17: 'False triggering',
            18: 'Activity (Warning)',
            19: 'Activity (Critical)',
            20: 'Catch',
            21: 'Activity noticed',
            22: 'Activity threshold reached',
            23: 'Bait low',
            24: 'Activity threshold reached and bait low',
            25: 'Activity threshold reset'
        },
        reportTypesDescription: {
            0: 'The device was restarted and the new Wifi data has been transfered successfully.',
            1: 'The device was restarted.',
            2: 'A snap trap was triggered and requires manual inspection.',
            3: 'Snap traps are armed and the device is ready for the next catch.',
            '3-bait': 'Bait is available on the bait pad.',
            4: 'There might be connection issues: The device was unable to reach the server during the chosen heartbeat interval.',
            5: 'There are connection issues: The device was unable to reach the server during an extended time period and requires manual check-up on location.',
            6: 'The device is in beacon mode and can be located',
            7: 'The device couldn’t initiate beacon mode',
            8: 'The settings of the device (e.g. hearbeat interval or/and operation mode) have been changed.',
            9: 'A firmware update for the device was successfully made.',
            10: 'The battery level of this device is low. Please change the batteries.',
            11: 'The device is back online, there are no more connection issues.',
            12: 'The device has been turned off.',
            13: 'There seem to be connection issues: The connection at the position of this device seems to be unreliable.',
            14: 'A user reported an infestation (catch) for this device.',
            15: 'A user reported a light infestation for this device.',
            16: 'A user reported a heavy infestation for this device.',
            17: 'A false triggering of a snap trap was reported for this device.',
            18: 'A user reported activity at this device.',
            19: 'A user reported critical activity at this device.',
            20: 'A catch has been detected. Manual inspection is required.',
            21: 'An activity has been detected.',
            22: 'The activity threshold has been reached',
            23: 'The bait level is low, please refill the bait',
            24: 'The activity threshold has been reached and the bait level is low, please inspect the device',
            25: 'The activity threshold has been reset'
        },
        info: 'Info',
        warning: 'Warning',
        critical: 'Critical',
        infested: 'Infested',
        infestedDescription: 'Show infestation Events',
        catch: 'Catch',
        triggered: 'Triggered',
        triggeredDescription: 'Show the triggered Events',
        connectivity: 'Connectivity',
        connectivityDescription: 'Show the connectivity per Device',
        catchDescription: 'Catch description',
        settings: 'Settings',
        at: ' at ',
        comments: 'Comments',
        edit: 'Edit',
        delete: 'Delete',
        save: 'Save',
        deleteConfirmation: 'Are you sure you want to delete comment?',
        addComment: '+ Add comment',
        commentsAvailable: 'There are comments for this report',
        enterCommentPlaceholder: 'Enter comment...',
        commentEmptyEx: 'Please enter a comment',
        somethingWentWrong:
            'Something went wrong while capturing screenshots of floorplan',
        exportDenyMsg:
            'Please select the time range for the export of less than 3 months. You can set it in filters. Current time range is too big for the export.',
        changeRTToFT: 'Change report type to false triggering',
        changeRTToFTDescr:
            'The trap is empty? Please add a comment and optionally add a picture of the trap. After the confirmation this catch report will be changed to the false triggering report',
        changeRTToCatch: 'Change report type to catch',
        changeRTToCatchDescr:
            'There is a catch in the trap? Please add a comment and optionally add a picture of the trap. After the confirmation this false triggering report will be changed to the catch report'
    },
    userManagement: {
        userManagement: 'User management',
        users: 'Users',
        roles: 'Roles',
        roleName: 'Role name',
        customer: 'Organization',
        actions: 'Actions',
        createNew: 'Create new',
        addFromAnotherOrg: 'Add from another organisation',
        noUsersFound: 'No users found',
        emailIsEmpty: 'Email is empty',
        isNotEmail: ' is not an email',
        fillInEmail:
            'Please fill in the email of user from another organisation.',
        onlyToYourOrg: 'You are able to add a user only to your organisation',
        chooseRole: 'Please choose a role for the user',
        verify: 'Verify',
        add: 'Add',
        whichOrgToCreateUser:
            'Which organization do you want to create a user in?',
        create: 'Create',
        pickOrgToDeleteUser:
            'Please pick the organization you want to delete the user from',
        sureDeleteUser: 'Are you sure you want to delete this user?',
        sureDeleteUsers: 'Are you sure you want to delete these users?',
        nameIsTooShort: 'Name is too short',
        emailIsNotCorrect: 'Email is not correct',
        genPassword: 'Generate password',
        changePassword: 'Change password',
        noRolesFound: 'No roles found',
        component: 'Component',
        read: 'Read',
        update: 'Update',
        delete: 'Delete',
        roleNotFound: 'Role was not found',
        defaultRoles: {
            [DEFAULT_ROLES.traplinked_admin]: 'traplinked admin',
            [DEFAULT_ROLES.customer_admin]: 'Organization admin',
            [DEFAULT_ROLES.viewer]: 'Viewer',
            [DEFAULT_ROLES.management_user]: 'Management user',
            [DEFAULT_ROLES.read_only_user]: 'Read only user',
            [DEFAULT_ROLES.location_management_user]:
                'Location management user',
            [DEFAULT_ROLES.technician]: 'Technician'
        },
        youCanNotDeleteThisUser: 'You can not delete this user',
        youCanNotDeleteThisRole: 'You can not delete this role',
        internalUser: 'Internal user',
        externalUser: 'External user',
        createUserModalTitle: 'Create new user',
        createExternalTitle: 'Create external user',
        createInternalTitle: 'Create internal user',
        userRalationStepTitle: 'Choose user relation',
        credentialsStepTitle: 'Login & Password',
        createRoleStepTitle: 'Create custom role',
        selectRoleStepTitle: 'Choose role for user',
        selectLocationsStepTitle: 'Choose locations',
        reviewStepTitle: 'Final review',
        nextStep: 'Next step',
        stepBack: 'Step back',
        completeBtn: 'Complete',
        backToDefaultRoles: 'Back to default roles',
        userRalationOptionName: {
            [USER_RELATIONS.internal]: 'Internal',
            [USER_RELATIONS.external]: 'External'
        },
        userRalationOptionDescription: {
            [USER_RELATIONS.internal]:
                'New user account for a person that works in your organisation, suitable for your employee that still does not have account in traplinked system',
            [USER_RELATIONS.external]:
                'New user account/access to your organisation from an external organisation, suitable contractors that still do not have a user account or already have one'
        },
        firstName: 'First name',
        lastName: 'Last name',
        password: 'Password',
        customerName: 'Customer name',
        userRelationExplanation: {
            [RELATIONS.internal]:
                'The user with this email already exists in your organisation as internal',
            [RELATIONS.externalIn]:
                'The user with this email already exists in your organisation as an external',
            [RELATIONS.externalOut]:
                'You can add this user to the organisation only as an external. Do you want to proceed?',
            [RELATIONS.nonexistent]: ''
        },
        roleNames: {
            [DEFAULT_ROLES.customer_admin]: 'Administrator',
            [DEFAULT_ROLES.viewer]: 'Viewer',
            [DEFAULT_ROLES.management_user]: 'Manager',
            [DEFAULT_ROLES.technician]: 'Technician',
            [CUSTOM_ROLE]: 'Custom'
        },
        roleDescription: {
            [DEFAULT_ROLES.customer_admin]:
                'Full scope of permissions in the system: can manage locations, devices, users and rest',
            [DEFAULT_ROLES.viewer]:
                'Does not have access to user management, can only read and view assigned locations, see the status of devices, reports from the assigned locations',
            [DEFAULT_ROLES.management_user]:
                'Can create and manage locations but can not delete them, can manage devices, reports, can manage users but can not delete them',
            [DEFAULT_ROLES.technician]:
                'Does not have access to user management, can create, manage and delete assigned locations, can manage devices and reports from assigned locations',
            [CUSTOM_ROLE]: 'Customisable role'
        },
        createNewCustomrole: '+ Create a new Custom Role',
        selectExistingCustomRole: 'Select custom role',
        deselectAllLocations: 'Deselect all',
        selectAllLocations: 'Select all',
        showTheUserInTheList: 'show the user in the list',
        youCanProceedWithRoleSelection:
            'You can proceed with the role selection for this external user',
        sendInvitationMail: 'Send invitation E-Mail',
        invitationModalText:
            'Are you sure you want to send the invitation to this user?',
        usersStillAssigned: 'Users are still assigned to that role',
        usersAssignedTheRole:
            'There are still users assigned the role that you want to delete',
        reassignThatUsers:
            'Please reassign that users another role before you delete this',
        deleteRoleConfirmation: 'Are you sure you want to delete this role?',
        reassignAndDeleteModal: {
            header: 'Users are still assigned that Role',
            textOne:
                'There are still users assigned the role that you want to delete',
            textTwo:
                'Please reassign that users another role before you delete this'
        }
    },
    sharing: {
        sharing: 'Sharing',
        chooseUsers: 'Choose users',
        chooseItems: 'Choose items to share',
        confirmAndShare: 'Confirm and share',
        organisation: 'Organization',
        noUsersToShare:
            'Currently there are no users added from another organization.',
        pleaseAddUsers: 'Please add users from another organization',
        userMgmt: ' User Management',
        noUsersLeft: 'No users to choose left',
        noUsersSelected: 'No users selected for sharing yet',
        locations: 'Locations',
        devices: 'Devices',
        reports: 'Reports',
        serialNr: 'Serial Nr',
        noDevicesToShare: 'Currently there are no devices to share',
        noDevicesLeft: 'No devices to choose left',
        noDevicesSelected: 'No devices selected yet',
        noReportsToShare: 'Currently there are no reports to share',
        noReportsLeft: 'No reports left to choose from',
        noReportsSelected: 'No reports selected yet',
        address: 'Address',
        noLocationsToShare: 'Currently there are no locations to share',
        contactSupport: 'If you see this message, please contact the support',
        noLocationsLeft: 'No locations left to choose from',
        noLocationsSelected: 'No locations selected yet',
        willBeSharedWith: 'Will be shared with:',
        successShare: 'Successfully shared'
    },
    detachedSharing: {
        noDataToShare: 'Currently there is no data to share',
        chooseUsers: 'Choose users',
        chooseItems: 'Choose items to share',
        confirmAndShare: 'Confirm and share',
        noDevicesSetupYet: 'No devices have been set up on this location yet.',
        devicesSelected: 'Devices selected',
        locationsSelected: 'Locations selected',
        selected: 'Selected',
        shareWithUsers: 'Share with users',
        existingFromAnotherOrg: 'added from another organization',
        byEmailFromAnotherOrg: 'by e-mail',
        noUsersToShare:
            'Currently there are no users added from another organization. You can share by e-mail.',
        usersSelected: 'Users selected',
        plsTypeInEmail: 'Please type in valid e-mail address',
        chooseRole: 'Please choose a role',
        addUsersEmails: 'Add users e-mail address(es)',
        location: 'Location',
        device: 'Device',
        serialNr: 'Serial Nr',
        dataForSharing: 'Data for sharing',
        willBeSharedWith: 'Will be shared with',
        locationsPath: 'Location path',
        nothingFound: 'Nothing found'
    },
    settings: {
        faq: 'FAQ',
        language: 'Language',
        settings: 'Settings',
        logout: 'Logout',
        emailNotificationsEnabled: 'E-mail notifications',
        pushNotificationsEnabled: 'Push notifications',
        smsNotificationsEnabled: 'SMS notifications',
        trapsTriggeredNotificationsEnabled: 'Device triggered',
        trapsInactiveemailNotificationsEnabled: 'Device down',
        batteryEmptyNotificationsEnabled: 'Low battery',
        batterySetupNotificationsEnabled: 'Device was set up',
        trapOnlineNotificationsEnabled: 'Device is back online',
        unstableConnectionNotificationsEnabled:
            'Device has unstable connection',
        baitLowNotificationsEnabled: 'Device has low bait position',
        activityThresholdReachedNotificationsEnabled:
            'Device has reached activity threshold',
        baitLowAndActivityThresholdReachedNotificationsEnabled:
            'Device has low bait position and has reached activity threshold',
        acceptSharedData: 'Update shared data',
        notificationsChannels: 'Notification Types',
        notificationsEvents: 'Notifications',
        nameIsTooShort: 'Name is too short',
        phoneNumberErr: 'Phone number is not valid',
        organisationPhoneNumberErr: 'Organisation phone number is not valid',
        reportBug: 'Report a bug',
        viewOurRoadmap: 'View our Roadmap',
        voteOnNewFeatures: 'Vote on new features',
        termsOfService: 'Terms of Service',
        termsConditions: 'Terms & Conditions',
        privacyPolicy: 'Privacy Policy',
        simCards: 'SIM Cards',
        billingPortal: 'Billing',
        portalError: 'Error loading Stripe billing portal'
    },
    login: {
        emailIsRequired: 'Email is required to sign in',
        passwordIsRequired: 'Password is required to sign in',
        forgotPassword: 'Forgot password?',
        signIn: 'Sign in',
        newInTraplinked: 'New customer? Please sign up.'
    },
    twoFactor: {
        title: 'Two-factor authentication',
        helperText: 'Enter the 6-digit code we sent to your email',
        verify: 'Verify',
        backToLogin: 'Back to login'
    },
    resetPassword: {
        resetPassword: 'Reset password',
        backToLogin: 'Back to login',
        goToLogin: 'Go to login',
        passwordIsTooShort: 'Password is too short',
        passwordsDoNotMatch: 'Passwords do not match'
    },
    register: {
        nameIsTooShort: 'Name is too short',
        emailIsNotCorrect: 'Email is not correct',
        passwordIsTooShort: 'Password is too short',
        passwordsDoNotMatch: 'Passwords do not match',
        registerUser: 'Register User',
        haveAlreadyUser: 'Already have an account? Please login.',
        pleaseEnterOrgName:
            'Please enter the name of your organization, it is required',
        orgName: 'Organization name',
        registerOrg: 'Register Organization',
        everythingIsReady:
            'Your new user and new organization are ready, now you can log in',
        goToLogin: 'Go to login',

        registerYourOrganization: 'Register your Organization',
        youAreAPestController:
            'You are a pest controller and want to register your organization',
        alreadyHaveAnAccount: 'Already have an account?',
        login: 'Log in',
        or: 'Or',
        joinAnExistingOrganization: 'Join an existing Organization?',
        accessYourOrganization:
            "If you're a technician or a team member looking to access your organization, ask your Admin to invite you.",
        notSureWhoYourAdmin:
            'Not sure who your Admin is or facing issues? Contact our support team for assistance.'
    },
    apiKeys: {
        apiKeys: 'API keys',
        apiKey: 'API key',
        viewDocs: 'View REST docs',
        copied: 'Copied',
        failedToCopy: 'Failed to copy',
        createNew: 'Create new',
        expires: 'Expires',
        noApiKeysFound: 'No API keys found',
        plsProvideDescr: 'Please provide the description for the API key',
        deleteKeyDescr:
            'If you delete this API key, access to the data via this API key is no longer possible. Are you sure you want to delete this API key?',
        viewKeyDescr:
            'Enter the API key in the third-party software so that it can display your device data. If the manufacturer offers a corresponding function, you can also scan the QR code to enter the API key.'
    },
    integrations: {
        integrations: 'Integrations',
        documentationTools: 'Documentation tools',
        apiKeys: 'API keys',
        pestsoft: 'Pestsoft',
        debuxx: 'DEBUXX',
        pestscan: 'Pestscan',
        pestscanPcoId: 'Pestscan PCO ID',
        username: 'Username',
        enterPassword: 'Enter password',
        credentialsRequired:
            'Enter and save credentials to complete the connection.',
        pestscanPcoIdRequiredWhenEnabled:
            'PCO ID is required when Pestscan is enabled.',
        debuxxHint: {
            toggle: 'How do I get these credentials?',
            title: 'Create a DEBUXX API user',
            body: 'Admins can create an API user in DEBUXX under **Einstellungen → Erweiterungen** by choosing a username and password. Copy them here to connect.',
            support:
                'Still need help? Contact DEBUXX support if you have additional questions on how to create or retrieve these credentials.'
        },
        pestscanHint: {
            toggle: 'How do I get my PCO ID?',
            title: 'Create a PC40 profile in Pestscan',
            steps: {
                1: 'Navigate to **General Settings** using the cog wheel in the main navigation bar.',
                2: 'Select **Permanent Monitoring** from the menu.',
                3: 'Open the **Profiles** tab and click **New**.',
                4: 'Set **Description** to something clear, such as PC40.',
                5: 'Set **Type** to PC40.',
                6: 'Click **Save**.',
                7: 'Copy the resulting **PCO ID** and paste it here.'
            },
            support:
                'Still need help? Contact Pestscan support if you have additional questions on how to obtain your PCO ID.'
        },
        settingsUpdated: 'Integration settings updated',
        settingsUpdateFailed: 'Failed to update integration settings',
        loadFailed: 'Failed to load integration settings',
        summaryTitle: 'Integrations & API overview',
        apiKeysCount: 'API keys',
        webhooks: 'Webhooks',
        webhooksTab: {
            title: 'Webhooks',
            viewDocs: 'View webhook docs',
            createWebhook: 'Create webhook',
            editWebhook: 'Edit webhook',
            deleteWebhook: 'Delete webhook',
            confirmDeleteWebhook:
                'This will permanently delete the webhook. This action cannot be undone.',
            noWebhooksFound: 'No webhooks yet',
            emptyBody:
                'Webhooks deliver real-time device events to your endpoints. Create one to start receiving data.',
            editorSubtitle: 'Webhooks deliver real-time device events',
            webhookCreated: 'Webhook created',
            webhookUpdated: 'Webhook updated',
            webhookDeleted: 'Webhook deleted',
            createFailed: 'Failed to create webhook',
            updateFailed: 'Failed to update webhook',
            deleteFailed: 'Failed to delete webhook',
            loadFailed: 'Failed to load webhooks',
            statusEnabled: 'Enabled',
            statusDisabled: 'Disabled',
            saveChanges: 'Save changes',
            cancel: 'Cancel',
            never: '--',
            fields: {
                status: 'Status',
                name: 'Name',
                description: 'Description',
                endpoint: 'URL',
                webhookType: 'Type',
                requestMethod: 'Method',
                reasons: 'Report types',
                reasonSingular: 'report type',
                reasonPlural: 'report types',
                reasonsTotalSuffix: 'available',
                isEnabled: 'Enabled',
                isEnabledHint:
                    'When on, events matching the selected report types are delivered.',
                headers: 'Headers',
                lastResponse: 'Last response',
                lastResponseCode: 'Last response code',
                lastRequestTimestamp: 'Last request'
            },
            placeholders: {
                name: 'My webhook',
                endpoint: 'https://example.com/webhooks/traplinked',
                description: 'What is this webhook for?',
                reasonsEmpty: 'Select one or more report types…'
            },
            headers: {
                keyHeader: 'Key',
                valueHeader: 'Value',
                keyPlaceholder: 'e.g. Authorization',
                valuePlaceholder: 'Value',
                addRow: 'Add header',
                removeRow: 'Remove header',
                maskedHint: '•••••• re-enter to overwrite',
                renamedHint: 'Renamed — re-enter the value',
                versionRequired: 'Required',
                versionLatestHint: 'latest is',
                versionLatestSuffix: 'latest',
                empty: 'No custom headers yet. Add one to authenticate your requests.'
            },
            validation: {
                nameRequired: 'Name is required',
                endpointRequired: 'URL is required',
                reasonsRequired: 'Select at least one report type',
                headerKeyRequired: 'Header key is required',
                headerValueRequired: 'Header value is required',
                headerKeyDuplicate: 'Header keys must be unique',
                versionReserved:
                    'traplinked-Version is set above, not as a custom header'
            },
            reasonGroupLabels: {
                device: 'Device status',
                trap: 'Trap events',
                image: 'Images',
                heartbeat: 'Heartbeat',
                activity: 'Activity & bait'
            },
            reasonLabels: {
                image_received: 'Image received',
                image_ai_processed: 'Image AI processed',
                heartbeat_received: 'Heartbeat received',
                trap_triggered: 'Trap triggered',
                battery_low: 'Battery low',
                catch_detected: 'Catch detected',
                rearmed: 'Rearmed',
                offline: 'Offline',
                online: 'Online',
                configured: 'Configured (initial factory setup)',
                maintained: 'Maintained (factory servicing)',
                switched_off: 'Switched off',
                catch_reported: 'Catch reported',
                false_triggering: 'False triggering',
                activity_noticed: 'Activity noticed',
                activity_threshold_reached: 'Activity threshold reached',
                bait_low: 'Bait low',
                activity_threshold_reached_and_bait_low:
                    'Activity threshold reached and bait low'
            },
            typeLabels: {
                traplinked: 'traplinked',
                rentokil_tom_images: 'Rentokil TOM images',
                pestsoft: 'Pestsoft',
                axinsectai: 'AxInsectAI'
            },
            methodLabels: {
                post: 'POST',
                put: 'PUT',
                patch: 'PATCH',
                get: 'GET',
                delete: 'DELETE'
            }
        },
        billingNotice:
            'Active integrations and API keys add €0.10 per device per month for devices that pinged at least once since the start of the month. Devices created on or before 31.12.2024 are exempt.',
        openBillingDashboard: 'Open billing dashboard',
        billingDataLoadFailed: 'Failed to load integrations & billing overview',
        billingModalTitle: 'Enabling this affects your billing',
        billingModalIntro:
            'Activating any integration, API key or webhook starts the integrations billing tier for your organization. Details:',
        billingModalRulePrice: 'Cost: €0.10 per device per month',
        billingModalRuleHeartbeat:
            'Charged only for devices that have sent at least one signal (heartbeat) within the month',
        billingModalRuleGrandfathered:
            'Devices online since or before 31.12.2024 incur no costs',
        billingModalConfirm: 'I agree, enable it',
        billingModalCancel: 'Cancel'
    },
    sagasMsgs: {
        /* common */
        getReportSharingHistoryEx: 'Error while getting report sharing history',
        commonLoadingError: 'Something went wrong. Please try again',
        /* login */
        loginEx: 'Login data is incorrect',
        loginWithTsEx: 'An error occurred, please contact the support.',
        sessionEx: 'Your session has expired',
        verify2faEx: 'Invalid or expired code. Please try again.',
        updataProfileRes: 'Profile has been updated.',
        updataProfileEx: 'Error while updating profile',
        pswdChangeRes: 'Password has been changed.',
        pswdChangeEx:
            'Error while changing the password, be sure the old password is correct.',
        forgotPswdRes:
            'A link to reset your password has been sent to your email address.',
        forgotPswdEx: 'Error occurred while requesting the password reset',
        resetPswdRes:
            'Password has been changed successfully, you can now login.',
        resetPswdEx:
            'An error occurred, please try to reset the password again on the login page',
        saveLocaleEx:
            'An error occurred while trying to save the language setting.',
        /* customers */
        getCustomersEx: 'An error occurred while loading customers',
        getCustomerEx: 'An error occurred while loading customer',
        updateCustomerEx: 'An error occurred while updating the customer',
        updateCustomerRes: 'The customer has been successfully updated',
        getSoftwarePlansEx: 'An error occurred while loading software plans',
        /* locations */
        getLocationsEx: 'An error occurred while loading locations',
        getLocationEx: 'An error occurred while loading the location',
        updateLocationRes: 'Location has been successfully updated',
        updateLocationEx: 'An error occurred while updating the location',
        createLocationRes: 'Location has been successfully created',
        createLocationEx: 'An error occurred while creating the location',
        deleteLocationRes: 'Successfully deleted location(s)',
        deleteLocationEx: 'An error occurred while deleting location(s)',
        shareLocationRes: 'Shared successfully',
        shareLocationEx: 'An error occurred while sharing location(s)',
        getLocationDevicesEx:
            'An error occurred while getting devices of location',
        getLocationReportsEx:
            'An error occurred while getting reports of location',
        getLocationSharedUsersEx:
            'An error occurred while getting location share information',
        getAvailableDevicesEx:
            'An error occurred while loading available devices to add',
        moveDevicesRes: 'Successfully added devices to location',
        moveDevicesEx: 'An error occurred while adding devices to location',
        createFloorPlanRes: 'Floor plan has been successfully created',
        createFloorPlanEx: 'An error occurred while creating floor plan',
        getFloorPlanEx: 'An error occurred while loading floor plan',
        deleteFloorPlanRes: 'Successfully deleted floor plan',
        deleteFloorPlanEx: 'An error occurred while deleting the floor plan',
        getFPAvailableDevicesEx:
            'An error occurred while loading available devices to add to the floor plan',
        addDevicesToFPEx:
            'An error occurred while adding devices to floor plan',
        updateFPDeviceEx:
            'An error occurred while updating device of floor plan',
        deleteFPDeviceEx:
            'An error occurred while deleting device from floor plan',
        /* devices */
        getDevicesEx: 'An error occurred while loading devices',
        getDeviceEx: 'An error occurred while loading device',
        getDeviceReportsEx: 'An error occurred while loading device reports',
        shareDevicesRes: 'Shared successfully',
        shareDevicesEx: 'An error occurred while sharing device(s)',
        resetDeviceRes: 'Successfully resetted device',
        resetDeviceEx: 'An error occurred while resetting device',
        reportCatchRes: 'Successfully reported catch',
        reportCatchEx: 'An error occurred while reporting catch',
        setOfflineRes: 'Successfully set offline',
        setOfflineEx: 'An error occurred while setting device offline',
        batteryResetRes: 'Successfully reset battery',
        batteryResetEx: 'An error occurred while resetting battery',
        updateDeviceRes: 'Successfully updated device',
        updateDeviceEx: 'An error occurred while updating device',
        getPestControlSystems:
            'An error occurred while loading pest control systems',
        tomStatusResetRes: 'Successful status reset',
        tomStatusResetEx: 'Error occurred while resetting status',
        /* reports */
        getReportsEx: 'An error occurred while loading reports',
        getReportEx: 'An error occurred while loading report',
        getLastReportDateEx: 'An error occurred while loading last report date',
        /* user mgmt */
        getUsersEx: 'An error occurred while loading users',
        getUserEx: 'An error occurred while loading user',
        getRoleEx: 'An error occurred while loading role',
        createRoleRes: 'Role has been succesfully created',
        createRoleEx: 'An error occurred while creating role',
        updateRoleRes: 'Role has been succesfully updated',
        updateRoleEx: 'An error occurred while updating role',
        getRolesEx: 'An error occurred while fetching roles',
        updateUserRes: 'User has been succesfully updated',
        updateUserEx: 'An error occurred while updating user',
        createUserRes: 'User has been succesfully created',
        createUserEx: 'An error occurred on creating user',
        deleteUserRes: 'Succesfully deleted',
        deleteUserEx: 'An error occurred while deleting user',
        membershipEx: 'An error occurred while requesting user membership',
        addToOrgRes: 'Succesfully added user(s) to organization',
        addToOrgEx: 'An error occured while adding users to organization',
        sendInvitationRes: 'Invitation was successfully sent to the user',
        sendInvitationEx: 'An error occurred while sending the invitation',
        deleteRoleRes: 'Role has been succesfully deleted',
        deleteRoleEx: 'An error occurred while deleting role',
        /* sharing */
        revokeSharingRes: 'Successfully revoked shared access',
        revokeSharingEx: 'An error occurred while revoking shared access',
        getSharingDataEx: 'An error occurred while loading sharing component',
        shareEx: 'An error occurred while sharing entities',
        /* api-keys */
        getApiKeysEx: 'An error occurred while loading API keys',
        createApiKeyRes: 'Successfully created API key',
        createApiKeyEx: 'An error occurred while creating API key',
        deleteApiKeyRes: 'Successfully deleted API key',
        deleteApiKeyEx: 'An error occurred while deleting API key',
        getApiKeyEx: 'An error occurred while loading API key',
        /* register */
        registerUserRes: 'User has been successfully created',
        registerUserEx: 'An error occurred while creating user',
        registerCustomerRes: 'Organization has been successfully created',
        pleaseUseEmail: 'Please use email and password of your new user',
        registerCustomerEx: 'An error occurred while creating organization',
        /* detached sharing */
        getDetachedSharingDataEx:
            'An error occurred while loading data for sharing',
        shareDetachedSharingDataRes: 'Successfully shared',
        shareDetachedSharingDataEx: 'An error occurred while sharing entities',
        tomMakeReport: 'Error occurred while creating report',
        getTomPicturesEx: 'Error occurred while loading TOM Pictures',
        mailSendRes: 'Email sent successfully',
        mailSendEx: 'Failed to send Email',
        organisationPhoneEx: 'Failed to save organisation phone number',
        commentDeleteRes: 'Comment deleted successfully',
        commentDeleteEx: 'An Error Occurred while deleting comment',
        commentAddRes: 'Comment added successfully',
        commentAddEx: 'An error occurred while adding comment',
        commentEditRes: 'Comment edited successfully',
        commentEditEx: 'An error occurred while editing comment',
        getCommentsEx: 'An error occurred while loading comments',
        deviceImagesAddRes: 'Added successfully',
        deviceImagesAddEx: 'An error occurred while adding',
        deviceImagesEditRes: 'Edited successfully',
        deviceImagesEditEx: 'An error occurred while editing',
        getDeviceImagesEx: 'An error occurred while loading',
        getLocationsByCustomerIdEx:
            'An error occurred while loading locations by customer id',
        getEscalationLevelEx:
            'An error occurred while loading escalation levels',
        postEscalationLevelEx:
            'Error occurred while creating escalation levels',
        postEscalationLevelRes: 'Added escalation levels successfully',
        getDeviceHistoryEx: 'An error occurred while loading device history',
        getUserPreferencesByTypeEx:
            'An error occurred while loading user preferences',
        patchUserPreferencesEx:
            'An error occurred while updateing user preferences',
        postUserPreferencesEx:
            'An error occurred while creating user preferences',
        exportFileEx: 'An error occurred while exporting file',
        getSimCardEx: 'An error occurred while loading sim card',
        updateSimCardRes: 'Sim card has been succesfully updated',
        updateSimCardEx: 'An error occurred while updating the sim card',
        createSimCardRes: 'Sim card has been succesfully created',
        createSimCardEx: 'An error occurred while creating the sim card'
    },
    common: {
        maintenanceMode: 'Maintenance mode',
        maintenanceDurationCustom: 'Custom',
        maintenanceDurationMinUnit: 'min',
        maintenanceDurationPositiveOnly:
            'Only positive whole numbers are allowed',
        maintenanceDurationDecrease: 'Decrease minutes',
        maintenanceDurationIncrease: 'Increase minutes',
        maintenanceDurationMinutes: 'Maintenance minutes',
        exitingMMode: 'Exiting maintenance mode',
        switchOnMMode: 'Switch on maintenance mode',
        switchOffMMode: 'Switch off maintenance mode',
        switchOnMModeDescr:
            'In maintenance mode reports are not being created and notifications are not being sent.',
        switchOffMModeDescr: 'Maintenance mode is going to be switched off.',
        ok: 'Ok',
        name: 'Name',
        save: 'Save',
        search: 'Search',
        cancel: 'Cancel',
        submit: 'Submit',
        clear: 'Reset filters',
        phone: 'Phone',
        organisationPhone: 'Organisation Phone',
        email: 'Email',
        organisation: 'Organization',
        role: 'Role',
        password: 'Password',
        passwordConfirmation: 'Password confirmation',
        changePassword: 'Change password',
        oldPassword: 'Old password',
        newPassword: 'New password',
        newPasswordConfiramtion: 'New password confirmation',
        errorContactSupport: 'An error occurred, please contact the support',
        revoke: 'Revoke',
        share: 'Share',
        delete: 'Delete',
        back: 'Back',
        next: 'Next',
        confirm: 'Confirm',
        skip: 'Skip',
        description: 'Description',
        trap: 'Trap',
        fourHours: '4 hours',
        sixHours: '6 hours',
        twelveHours: '12 hours',
        eighteenHours: '18 hours',
        twentyFourHours: '24 hours',
        acceptTerms: 'Accept',
        loading: 'Loading',
        copied: 'Copied',
        failedToCopy: 'Failed to copy',
        refresh: 'Refresh',
        confirmationCode: 'Confirmation code',
        passwordLength: 'Password has more than 8 characters.',
        passwordSpecialChar: 'Password has special characters.',
        passwordNumber: 'Password has a number.',
        passwordCapital: 'Password has a capital letter.',
        passwordLetter: 'Password has a letter.',
        nothingWasFound: 'Nothing was found',
        update: 'Update',
        newVersionIsAvailable: 'New Web App version is available!',
        pleaseClickUpdate:
            'Please click the button "Update" on the right side to update the application and we are ready to go!',
        required: 'Required',
        passwordErrorMessage: 'Password is not strong enough',
        notValidEmail: 'Not valid email',
        assigned: 'Assigned',
        assignment: 'Assignment',
        done: 'Done',
        settings: 'Settings',
        accountSettings: 'Account Settings',
        organisationSettings: 'Organisation Settings',
        exportCsv: 'Export CSV',
        exportExcel: 'Export Excel',
        exportPdf: 'Export PDF',
        exportQrPdf: 'Export with QR code',
        createNew: 'Create new',
        fileTooBig: 'The file is too large',
        emailTo: 'To',
        emailCc: 'Cc',
        advancedInformation: 'Advanced information',
        supportChat: 'Support Chat',
        account: 'Account',
        manual: 'Manual',
        support: 'Support',
        about: 'About',
        online: 'Online',
        offline: 'Offline',
        disconnected: 'Disconnected',
        notFilterable: 'Not filterable',
        expandTreeNodes: 'Expand all nodes',
        collapseTreeNodes: 'Collapse all nodes',
        applyFilters: 'Apply Filters',
        close: 'Close',
        login: 'Login',
        installation: 'Installation',
        success: 'Success'
    },
    tom: {
        openTomBtnTitle: 'New pictures to review',
        loadMore: 'Load more',
        contentType: 'Content type',
        reportType: 'Report type',
        createdAt: 'Created at',
        updatedAt: 'Updated ad',
        status: 'Status',
        bedbug: 'Bedbug',
        ant: 'Ant',
        roach: 'Roach',
        moth: 'Moth',
        cockroach: 'Cockroach',
        fly: 'Insects',
        other: 'Other',
        mouse: 'Mouse',
        rat: 'Rat',
        activated: 'Activated',
        activity: 'Activity',
        falseTrigger: 'False trigger',
        reviseReport: 'Revise report',
        openTom: 'Open TOM',
        user_processed: 'User processed',
        not_processed: 'Not processed',
        ai_processed: 'AI processed',
        ai_and_user_processed: 'AI and User processed',
        tomMode: 'TOM Mode',
        period: 'Period',
        pileEmpty: 'Pile is empty.',
        allProcessed: 'All pictures processed.',
        deviceName: 'Device name',
        companyName: 'Company name',
        dateTime: 'Date and time',
        operationMode: 'Operation mode',
        ok: 'OK',
        warning: 'Warning',
        critical: 'Critical',
        comments: 'Comments',
        aiProcessed: 'This picture was automatically processed with AI',
        userProcessed: 'This picture was processed by User',
        location: 'Location',
        system: 'System',
        noDevicePictures: 'No pictures yet',
        noPictures: 'There are no TOM pictures yet',
        notUsingTom: 'Not using our new product “TOM” yet?',
        discoverTom: 'Discover TOM',
        reportedBy: 'Reported by',
        amount: 'Amount',
        makeReport: 'Make report',
        relevantPictures: 'Relevant pictures',
        allPictures: 'All pictures'
    },
    mobileAppScreen: {
        title: 'We are currently optimizing our Web App for mobile Devices.',
        subtitle:
            'For the best user experience please download our App in the App Store or Google Play Store.'
    },
    addressForm: {
        firstName: 'First name',
        lastName: 'Last name',
        company: 'Company',
        streetAndNumber: 'Street & House Number',
        zip: 'ZIP Code',
        city: 'City',
        country: 'Country',
        note: 'Note',
        companyNameRequireValidationMessage: 'Company Name is required',
        companyNameMinLengthValidationMessage: 'Company name is too short',
        companyNameMaxLengthValidationMessage: 'Company name is too long',
        companyIsValidValidationMessage: 'Invalid company name',
        nameRequireValidationMessage: 'Name is required',
        nameMinLengthValidationMessage: 'Name is too short',
        nameMaxLengthValidationMessage: 'Name is too long',
        nameIsValidValidationMessage: 'Invalid name',
        lastNameRequireValidationMessage: 'Last name is required',
        lastNameMinLengthValidationMessage: 'Last name is too short',
        lastNameMaxLengthValidationMessage: 'Last name is too long',
        lastNameIsValidValidationMessage: 'Invalid last name',
        addressRequireValidationMessage: 'Street & House Number is required',
        addressIsValidValidationMessage: 'Invalid Street & House Number format',
        zipCodeRequireValidationMessage: 'ZIP Code is required',
        zipCodeIsValidValidationMessage: 'Invalid zip code',
        cityRequireValidationMessage: 'City is required',
        cityIsValidValidationMessage: 'Invalid city name',
        countryRequireValidationMessage: 'Country is required',
        countryIsValidValidationMessage: 'Invalid country name'
    },
    billing: {
        billing: 'Billing',
        externalUsersCreationNotice:
            'New external users created after 01.01.2025 are going to be charged each €2.50 net monthly. You can find the overview of your monthly subscriptions in the billing dashboard.',
        escalationLevelsCreationNotice:
            'New email addresses used for escalation levels assigned after 01.01.2025 are going to be charged each €2.50 net monthly. You can find the overview of your monthly subscriptions in the billing dashboard.',
        billingDashboard: 'Billing dashboard',
        lastHeartbeat: 'Last heartbeat',
        removedAt: 'Removed at',
        externalUsers: 'External users',
        amount: 'Amount',
        apiDevices: 'Devices API',
        monetisation: 'Monetisation',
        itCanUpToAMinute: 'It can take up to a minute',
        currentMonth: 'Current month'
    }
}

export default en

/*
([a-z]+)([:])
"$1"$2
*/
